import { Button } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import React, { useEffect, useState } from 'react';
import { SaveState } from '../../../../../../types';
import { FormInput } from '../../../../../components/form';
import { Panel } from '../../../../../components/panel/Panel';
import { Paragraph } from '../../../../../components/paragraph/Paragraph';
import { failureStateEventMappings } from './helpers';

interface IProcessBookingModalProps {
	propertyId: number | string;
	eventId: string;
	verificationFailures: any;
	submitOverridesSaveState: SaveState;
	onRequestClose: () => any;
	submitOverrides: (propertyId: string | number, eventId: string, overrides: string[]) => any;
}

export const ProcessBookingModal: React.FC<IProcessBookingModalProps> = (props) => {
	const { propertyId, eventId, verificationFailures, submitOverridesSaveState, onRequestClose, submitOverrides } = props;
	const [checked, setChecked] = useState({});
	const [displayComplete, setDisplayComplete] = useState(false);
	const [canSubmit, setCanSubmit] = useState(false);

	const onSave = async () => {
		const overrides = Object.keys(checked);
		await submitOverrides(propertyId, eventId, overrides);
	};

	useEffect(() => {
		setDisplayComplete(submitOverridesSaveState === SaveState.SUCCESS);
	}, [submitOverridesSaveState]);

	useEffect(() => {
		const numberSelected = Object.entries(checked).filter(([_, v]) => v).map(([k, _]) => k);
		setCanSubmit(numberSelected.length === Object.keys(verificationFailures).length);
	}, [checked]);

	const updateOverrides = (override: string) => {
		setChecked({ ...checked, [override]: !checked[override] });
	};

	return <Modal
		title="Process Booking"
		shouldCloseOnOverlayClick={false}
		onRequestClose={onRequestClose}
		actionRHS={displayComplete ? <></> :
			<Button
				id="process_booking_save"
				disabled={!canSubmit}
				onClick={onSave}
				bgColor={theme.colours.success.default}
				color={theme.colours.text.light}
				loading={submitOverridesSaveState === SaveState.PENDING}
			>
				Process booking
			</Button>}
	>
		<div className="process_booking_content">
			{displayComplete ?
				<>
					<Paragraph>This booking is now complete and has passed verification!</Paragraph>
					<Paragraph>
						The confirmation emails to the owner and guest will be sent shortly.
						If anything receives an error you will be notified via Intercom.
					</Paragraph>
					<Paragraph>You may close this booking.</Paragraph>
				</> :
				<>
					<Paragraph>This booking has failed verification for the following reasons.</Paragraph>
					<Paragraph>In order to proceed and process this booking you must confirm the below and click process booking</Paragraph>
					<div className="process_booking-approvals">
						{Object.keys(props.verificationFailures).map((failure) => {
							const { override, overrideDisplay } = failureStateEventMappings[failure];
							return <div className="process_booking-approvals_item">
								<FormInput
									id={`override_${override}`}
									name={`override_${override}`}
									type="checkbox"
									checked={checked[override]}
									value={override}
									onChange={(e) => updateOverrides(override)}
								/>
								<Paragraph>{overrideDisplay}</Paragraph>
							</div>;
						})}
					</div>
					{submitOverridesSaveState === SaveState.FAILURE && <Panel type="error">There was an issue processing the booking</Panel>}
				</>}
		</div>
	</Modal>;
};
